/*globals $:false */

import DefinitionM from './model/recordm.model.entity.definition.js';
import DefinitionP from './presenter/recordm.presenter.definition.js';
import DefinitionV from './view/recordm.view.definition.js';
import LogPresenter from '@cob/ui-genesis/modules/cob.log.js';

import { sprintf } from 'sprintf-js';

import tmpl_container from './templates/definition-container.dot';
import tmpl_log_entry from './templates/log-entry-json.dot';

import ui from '@cob/ui-genesis/cob.ui.js';
import utils from '@cob/ui-genesis/cob.utils.js';

var DefinitionDetail = function(core) {

    var _$mainContainer,
        _definitionP,
        _logPresenter,
        _definitionId;

    var _definitionM;

    var _loadingKey = core.getLoadingKey();

    var _loadDefinition = function(definitionId, definitionLoadLatch) {
        core.showLoading(_loadingKey, "_loadDefinition");

        DefinitionM.get(core, definitionId, {
            forceReload: true,

            success: function(definitionM) {
                _definitionM = definitionM;

                core.publish("modules:stack-description-updated");
                definitionLoadLatch.countDown("definition:loaded:" + definitionM.data.id);

                core.hideLoading(_loadingKey, "_loadDefinition.success");
            },

            error: function(status) {
                if (status === 404) {
                    ui.notification.showCustom(
                        'error',
                        sprintf(core.translateString("recordm.definition", "msg.error-title"), definitionId),
                        core.translateString("recordm.definition", "msg.not-found")
                    );
                }

                core.hideLoading(_loadingKey, "_loadDefinition.error");
            }
        });
    };


    var _init = function(definitionId) {
        _definitionId = definitionId || _definitionId;

        // Creating a latch because the code becomes more simple to read.
        // This will happen after the domain has been loaded successfully.
        var definitionLoadLatch = new utils.CountdownLatch(1, function() {

            core.showLoading(_loadingKey, "definitionLoadLatch");

            _$mainContainer = $(tmpl_container());
            core.translate("recordm.definition", _$mainContainer);

            _$mainContainer.appendTo('#'+core.getAppInstanceId());

            _definitionP = new DefinitionP(
                core,
                _definitionM,
                new DefinitionV(core, _$mainContainer)
            );
            _definitionP.init();

            // The log is beeing initialized after the instance has been shown
            // because the log container is inside the instance template.
            _$mainContainer.find(".js-log-container").removeClass("hidden");

            _logPresenter = new LogPresenter(core, $(".js-log-wrapper", _$mainContainer), {
                skipLocalize:true,

                prepare: function(logEntry){
                    var jsonMsg;

                    if(logEntry.message.startsWith('{')){
                        jsonMsg = JSON.parse(logEntry.message);

                        /* fazemos JSON.parse porque as mensagens de update de defs vêm com json dentro do text */
                        if(jsonMsg.text && jsonMsg.text.startsWith('{')){
                           jsonMsg.text = JSON.parse(jsonMsg.text).text;
                        }
                        Object.keys(jsonMsg).forEach((changeType) => {
                           if(changeType !== 'text'){
                              jsonMsg[changeType].forEach((value) => {
                                 value.before = utils.encodeHTML(value.before);
                                 value.after = utils.encodeHTML(value.after);
                              })
                           }
                        })

                        logEntry.message_original = jsonMsg;
                        logEntry.message = tmpl_log_entry(jsonMsg);
                    }
                }
            });
            _logPresenter.init("definition", definitionId);

            core.hideLoading(_loadingKey, "definitionLoadLatch.done");
        });

        _loadDefinition(_definitionId, definitionLoadLatch);
    };

    var _destroy = function() {
        if(_$mainContainer){
            _$mainContainer.remove();
        }

        if (_definitionM) {
            _definitionM.release();
            _definitionM = undefined;
        }

        if(_definitionP){
            _definitionP.destroy();
        }

        if(_logPresenter){
            _logPresenter.stop();
        }
    };

    return{
        init: _init,
        pause: _destroy,
        resume: _init,
        destroy: _destroy,

        getDescription: function() {
            if (_definitionM) {
                return {
                    definition: {
                        id: _definitionM.data.id,
                        name: _definitionM.data.name,
                        description: _definitionM.data.description
                    }
                }
            } else {
                return {
                    definition: {
                        id: _definitionId
                    }
                }
            }
        }
    };
};

export default DefinitionDetail;
